import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import  logo from '../images/logo.svg';
import blog from '../images/landing/blog.svg';
import hotbit from '../images/footer/hotbit.svg';
import probit from '../images/footer/probit.svg';
import hacken from '../images/haken.svg';
import zip from '../images/zip.svg';
import facebook from '../images/facebook.svg';
import youtube from '../images/youtube.svg';
import msg from '../images/msg.svg';
import twitter from '../images/twitter.svg';
import social from '../images/social.svg';
import email from '../images/email.svg';

class Footer extends Component {
  

  render() {
    return (
        <section className="footer">
  <footer >
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-md-1  mb-4 mb-md-0"></div>
        <div className="col-md-2 mb-4 mb-md-0">
          <h5 className="text-uppercase heading">Prostarter</h5>

          <ul className="list-unstyled mb-0">
            <li>
              <Link  to="/nft" >NFT Launchpad</Link>
            </li>
            <li>
              <Link  to="/nft-market" >NFT' MarketPlace</Link>
            </li>
            <li>
              <Link  to="/pro-king"><span>ProKing</span></Link>
            </li>
            <li>
            <Link to="/ido">Apply for IDO</Link>
            </li>
          </ul>
        </div>
        <div className="col-md-2 mb-4 mb-md-0">
          <h5 className="text-uppercase heading mb-0">Legal</h5>

          <ul className="list-unstyled">
            <li>
              <Link to="terms-condition" >Terms of Use</Link>
            </li>
            <li>
              <Link to="/privacy-policy" >Privacy Policy</Link>
            </li>
          </ul>
        </div>
        <div className="col-md-2 mb-4 mb-md-0">
          <h5 className="text-uppercase heading">Investor Center</h5>

          <ul className="list-unstyled mb-0">
            <li>
              <Link to="/contact" >Contact Us</Link>
            </li>
            <li>
              <Link to="/contact" >Invest with us</Link>
            </li>
            <li>
              <a rel="noreferrer" target=" _blank" href="https://forms.gle/ovn41C5BogfANpZB6">Partner with Us</a>
            </li>
            <li>
              <a target=" _blank"
               href="https://drive.google.com/file/d/1LHYXtvX9ym2on4LidyT4l0vSHXzMvhim/view?usp=sharing" >Investment Deck</a>
            </li>
            <li>
              <a target=" _blank" href="https://drive.google.com/file/d/1tEJQsuaywXyLug8GLfly7Kz8JVVbEeZJ/view?usp=sharing" >Whitepaper </a>
            </li>
          </ul>
        </div>
        <div className="col-md-1 mb-4 mb-md-0"></div>
        <div className="col-md-3 mb-4 mb-md-0">
          <img src={logo} alt="" className="mb-4"  width="150"/>
          <p>
          Prostarter is a community-centric and transparent DeFi platform coming up with lots of opportunties for Crypto community.
          </p>
          <p>Prostarter OÜ (registry code 16199742)</p>
          <p>Pärnu maakond, Pärnu linn, Pärnu linn, Papiniidu tn 5-706, 80042</p>
          <p className="connect">Connect with us!</p>
          <div className="social">
           <a target="_blank" rel="noreferrer" href="https://prostarter.medium.com"> <img  src={social} alt="" /></a>
           <a target="_blank" rel="noreferrer" href="https://twitter.com/ProtOfficial"> <img src={twitter} alt="" /></a>
            <a target="_blank" rel="noreferrer" href="https://t.me/Prostarter"><img src={msg} alt="" /></a>
           <a target="_blank" rel="noreferrer" href="https://www.facebook.com/Prostarter/"><img src={facebook} alt="" /></a>
           <a target="_blank" rel="noreferrer" href=" https://www.youtube.com/channel/UCGP3EtVL-A2Bpt83BOeaBkA/"><img src={youtube} alt="" /></a>
            <a target="_blank" rel="noreferrer" href="mailto: hello@prostarter.io"><img src={email} alt="" /></a>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-1"></div>
        <div className="col-md-10 my-5">
          <hr />
        </div>
        <div  className="col-md-1"></div>
      </div>
      <div className="row">
        <div className="col-md-1 mb-4 mb-md-0"></div>
        <div className="col-md-4 mb-4 mb-md-0">
          <a target="_blank" rel="noreferrer" href="https://openzeppelin.com/"> <img src={zip} alt=""/></a>
          <p className="zip-p">Token based on OpenZeppelin Contracts.</p>
          <p className="zip-p zzp"> OpenZeppelin Contracts is community-vetted code and is MIT licensed.</p>
        </div>
        <div className="col-md-4 mb-4 mb-md-0">
          <p>Partners</p>
          <div className="partners-div">
            <img src={hotbit} alt="" />
            <img src={blog} alt="" />
          </div>
          <div className="partners-div">
            <img src={probit} alt="" />
            <img className="hide" src={blog} alt="" />
          </div>
        </div>
        <div className="col-md-3 mb-4 mb-md-0">
          <p>Audited by:</p>
          <a href="https://drive.google.com/file/d/16aDt7zONj5nz7XO_O1GH-W8R9OEe-uUp/view?usp=sharing" target="_blank" rel="noreferrer" ><img className="blog-img" src={hacken} alt="" /></a>
        </div>
      </div>
    </div>
    <div className="text-center p-3 change" >
       Copyright © 2021. Prostarter.io . All rights reserved.
    </div>
  </footer>
</section>
     );
  }
}

export default withRouter(Footer);
